<div class="voice-agent" [class.connected]="connected">
  <!-- Background -->
  <div class="bg-glow"></div>

  <!-- AI Card -->
  <div class="agent-card">
    <div class="back-question-wrapper">
      <button class="back-question-btn" (click)="backToAskQuestion()">
        <i class="pi pi-arrow-left"></i>
        <span>Back to Ask Questions</span>
      </button>
    </div>
    <!-- Avatar -->
    @if (!showAvatar) {
    <div class="avatar-section">
      <!-- <div class="avatar-ring" [class.agent-speaking]="agentSpeaking" [class.user-speaking]="userSpeaking">
        <img [src]="avatarImage" class="avatar-img" alt="AI Avatar">
      </div> -->
      <div class="agent-avatar" [class.agent-avatar--speaking]="agentSpeaking" style="width: 150px">
        <img [src]="avatarImage" alt="AI Voice Agent" class="avatar-img" />
      </div>
      @if (!connected) {
      <h2>AI Voice Assistant</h2>
      } @if (!connected) {
      <p>
        {{
        connected
        ? "Talk naturally with your AI Assistant"
        : "Click Connect to start your voice session"
        }}
      </p>
      }
    </div>
    }

    <!-- Transcript -->
    @if (connected) {
    <div class="transcript-wrapper" [class.transcript-avatar]="showAvatar">
      <div class="transcript-container" #transcriptContainer>
        @for (item of transcripts; track trackTranscript($index, item)) {
        <div class="message-row" [class.agent]="item.isAgent" [class.user]="!item.isAgent">
          <div class="message-content">
            <div class="message-header">
              <span class="name">
                {{ item.isAgent ? "AI Assistant" : "You" }}
              </span>
              <!-- <span class="time">
                {{ item.startTime | date:'shortTime' }}
              </span> -->
            </div>
            <div class="bubble">
              {{ item.text }}
            </div>
          </div>
        </div>
        }
      </div>
      <div class="input-wrapper">
        <input [(ngModel)]="typedMessage" placeholder="Type your message..." [disabled]="!connected"
          (keyup.enter)="sendMessage()" />
        <button type="button" (click)="sendMessage()" [disabled]="!typedMessage.trim() || !connected">
          <i class="pi pi-send"></i>
        </button>
      </div>
    </div>
    }
  </div>

  <!-- Footer -->
  <!-- <div class="agent-footer">

<button class="circle-btn" *ngIf="connected" [class.active]="manualAudioMuted" [pTooltip]="manualAudioMuted ? 'Audio Unmute' : 'Audio Mute'" tooltipPosition="top" (click)="toggleAudioMute()">
      <img [src]="manualAudioMuted
      ? 'assets/images/audio-mute.png'
      : 'assets/images/audio-unmute.png'" [alt]="manualAudioMuted ? 'Audio Off' : 'Audio On'" width="24" height="24" />
  </button>

  <button class="circle-btn" *ngIf="connected" [class.active]="manualMuted"
    [pTooltip]="manualMuted ? 'Unmute' : 'Mute'" tooltipPosition="top" (click)="toggleMute()">

      <img [src]="manualMuted
      ? 'assets/images/mic-off.png'
      : 'assets/images/mic-on.png'" [alt]="manualMuted ? 'Mic Off' : 'Mic On'" width="24" height="24" />

    </button>

    <button class="circle-btn" pTooltip="{{showAvatar === true ? 'Show Avatar': 'Hide Avatar'}}" *ngIf="connected"
      [class.active]="showAvatar" (click)="toggleAvatar()">
      <img src="assets/images/ai_avatar.svg" alt="" srcset="">
    </button>

    <button class="call-btn" [class.connected]="connected" [class.connecting]="connecting" [disabled]="connecting"
      (click)="toggleSession()">

      <i class="pi" [ngClass]="{
                    'pi-spin pi-spinner':connecting,
                    'pi-phone':connected && !connecting,
                    'pi-play':!connected && !connecting
                }">
      </i>

      <span>
        {{
        connecting
        ? 'Connecting...'
        : connected
        ? ''
        : 'Connect'
        }}
      </span>

    </button>

  </div> -->

  <div class="agent-footer">
    <!-- =========================
    Agent Dropdown
    ========================== -->
    @if (!connected) {
    <div class="voice-select">
      <label for="providerSelect"> Voice Provider </label>
      <select id="providerSelect" [(ngModel)]="selectedProvider" (ngModelChange)="onProviderChange($event)"
        [disabled]="connecting">
        <option [ngValue]="null">Select Provider</option>
        @for (item of provider; track item) {
        <option [ngValue]="item.provider">
          {{ item.name }}
        </option>
        }
      </select>
    </div>
    } @if (!connected) {
    <div class="voice-select">
      <label for="voiceSelect"> Voice </label>
      <select [(ngModel)]="selectedVoice" (ngModelChange)="onVoiceChange($event)">
        <option [ngValue]="null">Select Voice</option>
        @for (voice of voiceList; track voice) {
        <option [ngValue]="voice">
          {{ voice.name }}
        </option>
        }
      </select>
    </div>
    }



    <!-- Audio -->
    @if (connected) {
    <button class="circle-btn" [class.active]="manualAudioMuted"
      [pTooltip]="manualAudioMuted ? 'Audio Unmute' : 'Audio Mute'" tooltipPosition="top" (click)="toggleAudioMute()">
      <img [src]="
          manualAudioMuted
            ? 'assets/images/audio-mute.png'
            : 'assets/images/audio-unmute.png'
        " [alt]="manualAudioMuted ? 'Audio Off' : 'Audio On'" width="24" height="24" />
    </button>
    }

    <!-- Microphone -->
    @if (connected) {
    <button class="circle-btn" [class.active]="manualMuted" [pTooltip]="manualMuted ? 'Unmute' : 'Mute'"
      tooltipPosition="top" (click)="toggleMute()">
      <img [src]="
          manualMuted ? 'assets/images/mic-off.png' : 'assets/images/mic-on.png'
        " [alt]="manualMuted ? 'Mic Off' : 'Mic On'" width="24" height="24" />
    </button>
    }

    <!-- Avatar -->
    @if (connected) {
    <button class="circle-btn" [class.active]="showAvatar" [pTooltip]="showAvatar ? 'Show Avatar' : 'Hide Avatar'"
      tooltipPosition="top" (click)="toggleAvatar()">
      <img src="assets/images/ai_avatar.svg" alt="Avatar" />
    </button>
    }

    <!-- Connect / Disconnect -->
    <button class="call-btn" [class.connected]="connected" [class.connecting]="connecting" [disabled]="
        connecting || (!connected && (!selectedProvider || !selectedVoice))
      " (click)="toggleSession()">
      <i class="pi" [ngClass]="{
          'pi-spin pi-spinner': connecting,
          'pi-phone': connected && !connecting,
          'pi-play': !connected && !connecting
        }"></i>

      <span>
        {{ connecting ? "Connecting..." : connected ? "" : "Connect" }}
      </span>
    </button>
    <div class="document-selector" *ngIf="connected">

      <!-- Document Icon -->
      <button type="button" class="circle-btn" (click)="toggleDocumentDropdown($event)" [pTooltip]="Documents" tooltipPosition="top">

        <img src="assets/images/document.png" width="24" height="24" alt="Documents">
      </button>


      <!-- Dropdown -->
      <div class="document-dropdown" *ngIf="showDocumentDropdown" (click)="$event.stopPropagation()">

        <!-- Icon at top -->
        <div class="dropdown-icon">
          <img src="assets/images/document.png" width="42" height="42" alt="Documents">
        </div>

        <!-- Title -->
        <div class="dropdown-title">
          <h4>Select Document</h4>
          <span>{{ documents.length }} documents available</span>
        </div>

        <!-- Search -->
        <div class="document-search">
          <i class="pi pi-search"></i>

          <input type="text" [(ngModel)]="documentSearch" placeholder="Search documents...">
        </div>

        <!-- Document list -->
        <div class="document-list">

          <div class="document-item" *ngFor="let document of filteredDocuments"
            [class.active]="selectedDocument?.message_id === document.message_id" (click)="selectDocument(document)">

            <div class="document-icon">
              <i class="pi pi-file-pdf"></i>
            </div>

            <div class="document-info">
              <div class="document-name">
                {{ document.message }}
              </div>

              <div class="document-meta">
                {{ document.file_ext || 'PDF' }}
              </div>
            </div>

            <i *ngIf="selectedDocument?.message_id === document.message_id" class="pi pi-check selected-icon">
            </i>

          </div>

        </div>

      </div>

    </div>
  </div>
</div>

<!-- =========================================================
     DOCUMENT PREVIEW OVERLAY
========================================================= -->

@if (selectedDocument) {

<div class="document-preview-overlay" (click)="closeDocumentPreview()">

  <div class="document-preview-modal" (click)="$event.stopPropagation()">

    <!-- ===================================================
           HEADER
      ==================================================== -->

    <div class="document-preview-header">

      <div class="preview-document-info">

        <div class="preview-file-icon">
          <img src="assets/images/document.png" alt="Document">
        </div>

        <div class="preview-file-details">

          <h3>
            {{ selectedDocument.message }}
          </h3>

          <span>
            {{ selectedDocument.file_ext || 'PDF Document' }}
            <span class="separator">•</span>
            {{ currentDocumentIndex + 1 }} of {{ documents.length }}
          </span>

        </div>

      </div>


      <!-- Header Actions -->

      <div class="preview-header-actions">

        <!-- Previous -->
        <button type="button" class="preview-action-btn" [disabled]="currentDocumentIndex === 0"
          pTooltip="Previous document" tooltipPosition="bottom" (click)="previousDocument()">

          <i class="pi pi-chevron-left"></i>

        </button>


        <!-- Next -->
        <button type="button" class="preview-action-btn" [disabled]="
              currentDocumentIndex === documents.length - 1
            " pTooltip="Next document" tooltipPosition="bottom" (click)="nextDocument()">

          <i class="pi pi-chevron-right"></i>

        </button>


        <!-- Close -->
        <button type="button" class="preview-close-btn" pTooltip="Close preview" tooltipPosition="bottom"
          (click)="closeDocumentPreview()">

          <i class="pi pi-times"></i>

        </button>

      </div>

    </div>


    <!-- ===================================================
           BODY
      ==================================================== -->

    <div class="document-preview-body">


      <!-- LEFT ARROW -->

      <!-- <button type="button" class="document-side-nav document-side-nav--left" [disabled]="currentDocumentIndex === 0"
        (click)="previousDocument()">

        <i class="pi pi-chevron-left"></i>

      </button> -->


      <!-- DOCUMENT -->

      <div class="document-preview-frame">

        @if (selectedDocument.view_url) {

        <ngx-doc-viewer [url]="selectedDocument.view_url" viewer="google" [googleCheckContentLoaded]="true"
          [googleCheckInterval]="3000" [googleMaxChecks]="5" style="width: 100%; height: 100%"
          (loaded)="contentLoaded()">
        </ngx-doc-viewer>

        } @else {

        <div class="document-no-preview">

          <div class="no-preview-icon">
            <i class="pi pi-file"></i>
          </div>

          <h4>
            Preview not available
          </h4>

          <p>
            This document cannot be previewed.
          </p>

        </div>

        }

      </div>


      <!-- RIGHT ARROW -->

      <!-- <button type="button" class="document-side-nav document-side-nav--right" [disabled]="
            currentDocumentIndex === filteredDocuments.length - 1
          " (click)="nextDocument()">

        <i class="pi pi-chevron-right"></i>

      </button> -->

    </div>


    <!-- ===================================================
           FOOTER
      ==================================================== -->

    <div class="document-preview-footer">

      <div class="document-position">

        <span>
          Document {{ currentDocumentIndex + 1 }}
        </span>

        <span class="position-divider">
          /
        </span>

        <span>
          {{ selectDocument.length }}
        </span>

      </div>


      <div class="document-footer-actions">

        <button type="button" class="document-footer-btn" [disabled]="currentDocumentIndex === 0"
          (click)="previousDocument()">

          <i class="pi pi-arrow-left"></i>
          Previous
        </button>


        <button type="button" class="document-footer-btn primary" [disabled]="
              currentDocumentIndex === selectDocument.length - 1
            " (click)="nextDocument()">

          Next
          <i class="pi pi-arrow-right"></i>

        </button>

      </div>

    </div>

  </div>

</div>

}